<script setup>
const { data: list } = await useFetch2("/api/qna");

const activeKey = ref(null);
</script>

<template lang="pug">
div.my-4(v-if="list && list.list && list.list.length")
  h1.text-center 常见问题
  a-collapse(v-model:activeKey="activeKey", :accordion="true")
    a-collapse-item(
      v-for="item in list.list",
      :key="item.id",
      :header="item.question"
    )
      div(v-html="item.answer")
</template>

